///////////////////////////////////////////////
//     							                         //
//  Program: PayoutBreakDownService.js       //
//  Application: Services                    //
//  Option: Used for payout data             //
//  Developer: Ashish Kumar                  //
//  Date: 2025-05-07                         //
//                                           //
///////////////////////////////////////////////

import CmsService from "./CmsService";

class PayoutBreakDownService {
  getPayoutDetails(header, queryString) {
    let endPoint = "payout-breakdown" + (queryString ? "?" + queryString : "");
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    return CmsService.getMobileCall(header, inputData);
  }
}

export default new PayoutBreakDownService();
